import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {IndividualConfig} from 'ngx-toastr/toastr/toastr-config';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {

  constructor(private toastr: ToastrService) { }

  showSuccess(message: string, title?: string, override?: Partial<IndividualConfig>) {
    this.toastr.success(message, title, override);
  }

  showError(message: string, title?: string, override?: Partial<IndividualConfig>) {
    this.toastr.error(message, title, override);
  }

  showWarning(message: string, title?: string, override?: Partial<IndividualConfig>) {
    this.toastr.warning(message, title, override);
  }

  showInfo(message: string, title?: string, override?: Partial<IndividualConfig>) {
    this.toastr.info(message, title, override);
  }


  // Les 4 méthodes sont à supprimer
  success(message: string, title?: string) {
    this.toastr.success(message, title);
  }

  error(message: string, title?: string) {
    this.toastr.error(message, title);
  }

  warning(message: string, title?: string) {
    this.toastr.warning(message, title);
  }

  info(message: string, title?: string) {
    this.toastr.info(message, title);
  }

}
